import { DenormalizedCustomizableGroup, DenormalizedCustomizableQuestion } from '@packages/types'
import React from 'react'

import useThemeSettings from 'customizer/theme/useThemeSettings'
import BottomDrawer from 'themes/common/components/bottomDrawer/BottomDrawer'
import type { BottomDrawerValues } from 'themes/common/components/bottomDrawer/useBottomDrawer'

import SummaryDrawerFooter from './SummaryDrawerFooter'
import SummaryDrawerHeader from './SummaryDrawerHeader'
import SummaryDrawerList from './SummaryDrawerList'

import './SummaryDrawer.scss'

export type SummaryDrawerProps = {
  drawer: BottomDrawerValues
  steps: (DenormalizedCustomizableGroup | DenormalizedCustomizableQuestion)[]
}

const SummaryDrawer = ({ drawer, steps }: SummaryDrawerProps) => {
  const titleStyle = useThemeSettings('customizerTitle')
  const summaryDrawerStyle = useThemeSettings('summaryDrawer')

  const handleNotchClick = () => {
    if (drawer.currentSnapPointIndex === 0) drawer.snap(1)
    else drawer.dismiss()
  }

  return (
    <BottomDrawer
      {...drawer.props}
      className="summary-drawer"
      style={{ backgroundColor: summaryDrawerStyle.backgroundColor }}
    >
      <BottomDrawer.Backdrop {...drawer.backdropProps} onClick={drawer.dismiss} />

      <BottomDrawer.Notch
        {...drawer.draggableProps}
        onClick={handleNotchClick}
        notchStyle={{ backgroundColor: summaryDrawerStyle.notchColor }}
      />

      <BottomDrawer.Content
        className="summary-drawer__content"
        containerClassName="summary-drawer__container"
        style={{ fontFamily: titleStyle.fontFamily?.fontFamily }}
      >
        <SummaryDrawerHeader {...drawer.draggableProps} />
        <SummaryDrawerList drawer={drawer} steps={steps} />
        <SummaryDrawerFooter onClose={drawer.dismiss} />
      </BottomDrawer.Content>
    </BottomDrawer>
  )
}

export default SummaryDrawer
